<template>
    <div class="card-data" :class="xl?'xl':'lg'">
        <Tooltip
            v-show="tip"
            :tip="tip" />
        <div class="card-title">
            <h5 class="title">{{title}}</h5>
            <small v-if="sub" class="sub-title">{{sub}}</small>
            <div style="height: 29px" v-else></div>
        </div>
        <div v-if="!loader">
            <Loader/>
        </div>
        <!-- <div v-else-if="data.length==0 || !nodata">
            <EmptyStateChart/>
        </div> -->
        <div :class="responsive ? 'apexchart' : ''" v-else-if="loader&&display">
            <apexchart  type="bar" :height="height" :options="chartOptions" :series="data"></apexchart>
        </div>
        <div v-else-if="!display">
            <img src="@/assets/no-results.svg" alt="No permitido" class="invalid-display">
            <p class="invalid-display-text">Este gráfico está disponible sólo en escritorio</p>
        </div>
        
        
    </div>
</template>

<script>
import Loader from '@/components/Loader'
import Tooltip from '@/components/Tooltip'
import EmptyStateChart from '@/components/EmptyStateChart'
import _ from 'lodash' 

export default {
    name: 'BarGraphCard',
    components: {
        Tooltip,
        Loader,
        EmptyStateChart
    },
    props: {
        title: {
            type: String,
            required: true
        },
        sub: {
            type: String,
            required: false
        },
        tip: {
            type: String,
            default: ""
        },
        data: {
            type: Array,
            required: true
        },
        periodItems: {
            type: Array,
            required: true
        },
        sm: {
            type: Boolean,
            required: false
        },
        loader: {
            type: Boolean,
            required: true
        },
        xl: {
            type: Boolean,
            default: false
        },
        responsive: {
            type: Boolean,
            default: false,
        },
        height: {
            type: String,
            default: "250"
        },
        captionEmpty:{
            type: String,
            default: "Este gráfico no está disponible actualmente",
        },
        titleEmpty: {
            type: String,
            default: "No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
        }
    },
    data: function(){
        return {
            tooltip: false
        }
    },
    computed: {
        display: function() {
            if(window.innerWidth < 768 && this.$store.getters["auth/getMaxRange"]){
                return false
            }
            return true
        },
        nodata: function(){
            let totaldata = 0
            _.each(this.data,(value)=>{
                _.each(value.data,(item)=>{
                    totaldata = totaldata + item 
                })
            }) 
            return totaldata
        },
        chartOptions: function() {
            return {    
                chart: {
                    type: 'bar',
                    stacked: true,
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: true
                    },
                    animations: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                colors: ["#7309cb", "#f18409", "#148aa4", "#a11461", "#cb0d4a", "#2d99ff", "#97c208", "#0196b7", "#1b35c5"],
                xaxis: {
                    type: 'categories',
                    categories: this.periodItems,
                    labels: {
                        rotate: -45,
                        rotateAlways: true,
                        hideOverlappingLabels: false,
                        maxHeight: 120,
                        formatter: function (value, timestamp) {
                            let monthNames = [
                                "Ene", "Feb", "Mar",
                                "Abr", "May", "Jun", "Jul",
                                "Ago", "Sep", "Oct",
                                "Nov", "Dic"
                            ]
                            if (value && value.includes('-')) {
                                return value.split('-')[0] + "-" + monthNames[value.split('-')[1] - 1]
                            } else if (value) {
                                if (value > 12) {
                                    return (value - 12).toString() + ":00 pm"
                                } else if (value == 12) {
                                    return  value + ":00 pm"
                                } else if (value == "00") {
                                    return "12:00 am"
                                }
                                return value + ":00 am"
                            }
                        }
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                legend: {
                    markers: {
                        radius: 12
                    }
                },
                yaxis: {
                    tickAmount: 1,
                    labels: {
                        formatter: function (value) {
                            return (value).toLocaleString('es')
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },
                fill: {
                    opacity: 1
                },
                responsive: this.responsive ? [{
                    breakpoint: 420,
                    options:{
                        chart:{
                            height: 80,
                            width: "100%",
                            type: "bar",
                            parentHeightOffset: 0,
                        },
                        yaxis:{
                            show: false,
                        },
                        xaxis:{
                            labels:{
                                show: false,
                            },
                            axisTicks:{
                                show: false,
                            },
                        },
                        grid:{
                            show: true,
                            padding:{
                                left: 8,
                                right: 8,
                                top: -10,
                                bottom: -10,
                            },
                        },
                        legend:{
                            show: false
                        },
                        tooltip:{
                            enabled: true,
                            fixed: {
                                enabled: true,
                                position: "topLeft",
                                offsetY: -55,
                            }
                        },
                    }
                    }
                ] : []
            }
        }
    }
}
</script>

<style lang="sass" scoped>
.card-title
    @include tablet-portrait
        margin-left: 8px
.invalid-display
    display: block
    max-width: 220px
    max-height: 220px
    margin: 12px auto 
.invalid-display-text
    width: 100%
    margin-bottom: 8px
    display: block
    font-family: Muli
    font-size: 16px
    text-align: center
    color: #302f2f
@include mobile
    .apexchart
        div
            background: $lighter-grey
            border-radius: 8px
            margin-bottom: 8px
</style>